import { getApiConfig } from '../services/api/utils';
import { uuid } from '../shared/utils';

export function buildMobiusLinkout(
  programId: string | number,
  capId: number,
  audience: string,
  publisherIdentityToken: string | undefined,
  mobiusApiUrl?: string,
): string | undefined {
  if (!publisherIdentityToken) {
    return undefined;
  }

  const baseUrl =
    mobiusApiUrl ||
    getApiConfig().mobiusApiUrl ||
    'https://api.mobius.highereducation.com';
  const params = `idToken=${publisherIdentityToken}&helid=${uuid()}`;

  return (
    `${baseUrl}/v1/redirect/${programId}/${capId}` +
    (audience !== '' && audience !== 'none' ? `/${audience}` : '') +
    `?${params}`
  );
}
